import {createContext} from 'react';

const AttachmentContext = createContext({
  createAttachment: () => {},
  createS3DirectUploadImage: () => {},
  updateAttachment: () => {}
});

export default AttachmentContext;
